module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_6005.71fbc228.png";